import React from 'react';
import { a } from 'kremling';

export const DrawerBody = ({ children, className, ...rest }) => (
  <div className={a("cp-drawer__body", className)} {...rest}>
    {children}
  </div>
);
